module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspOne.5304422.png";